import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public storage_user: Storage | null = null

  constructor(public http: HttpClient, public platform: Platform, public storage: Storage, public router: Router) {
    this.init()
  }

  async init() {
    const storage = await this.storage.create()
    this.storage_user = storage
  }

  login(user: any) {
    return this.http.post<any>(`${environment.apiUrl}/user/login`, user)
  }

  acceptPersonalData(id: any) {
    return this.http.put<any>(`${environment.apiUrl}/user/update_personal_data`, {id})
  }

  register(user: any) {
    return this.http.post<any>(`${environment.apiUrl}/user/signup`, user)
  }

  resetPassword(user: any) {
    return this.http.put<any>(`${environment.apiUrl}/user/forgot_password`, user).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload.data
        }
        return response
      })
    )
  }

  changePassword(user: any) {
    return this.http.put<any>(`${environment.apiUrl}/user/change_password`, user).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload
        }
        return response
      })
    )
  }

  getPlatform(): string {
    return this.getSystem() ? this.getCompilation() : 'Desconocida'
  }

  getSystem() {
    let platform: string = ''

    if (this.platform.is('desktop')) {
      platform = 'desktop'
    } else if (this.platform.is('ios')) {
      platform = 'ios'
    } else if (this.platform.is('android')) {
      platform = 'android'
    }

    if (platform) {
      platform += ' - '
    }

    return platform
  }

  getCompilation() {
    let platform: string = ''

    if (this.platform.is('cordova') || this.platform.is('capacitor')) {
      platform += ' - app'
    } else {
      platform += ' - browser'
    }

    platform += ' - '

    return platform
  }

  logout(isUpdate = false) {
    this.storage_user?.remove(environment.localStorage)
    if (isUpdate) {
      location.reload()
    } else {
      this.router.navigate(['login'])
    }
  }
}
